import { createElement, useCallback, useEffect, useState } from "react"
import { ErrorComponent } from "@/shared/components/ErrorComponent/ErrorComponent"
import { Loading } from "@/shared/components/Loading/Loading"

interface MicroFrontendContentProps {
  importUrl: string
  webComponentName: string
  customerId: string
}

export function MicroFrontendContent({ importUrl, webComponentName, customerId }: MicroFrontendContentProps) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  const loadScript = useCallback(async () => {
    try {
      if (!/^https?:\/\//.exec(importUrl)) {
        throw new Error("Invalid import URL format")
      }
      setLoading(true)
      setError(null)
      await import(/* @vite-ignore */ importUrl)
      if (!customElements.get(webComponentName)) {
        throw new Error(`Web component ${webComponentName} was not registered`)
      }
    } catch (error: unknown) {
      setError(error as Error)
    } finally {
      setLoading(false)
    }
  }, [importUrl, webComponentName])

  useEffect(() => {
    void loadScript()
  }, [loadScript])

  if (loading) {
    return <Loading />
  }

  if (error) {
    return <ErrorComponent error={error} onRetry={() => void loadScript()} />
  }

  // For some reason, attributes to web components do not support uppercase letters
  return createElement(webComponentName, {
    customerid: customerId
  })
}
